angular
  .module('company')

  .directive('companyExportTasksButton', [
    function() {
      return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: true,
        template:
          '<a href="" class="pv-follow-btn btn-primary" ng-transclude></a>',
        controller: [
          '$scope',
          '$element',
          'CompanyStore',
          'CompanyExportTasksCrud',
          function($scope, $element, CompanyStore, CompanyExportTasksCrud) {
            CompanyStore.listenTo(function(company) {
              $scope._id = company ? company._id : null;
            });

            $element.click(() => {
              $scope._id && CompanyExportTasksCrud.download($scope._id);
            });
          }
        ]
      };
    }
  ]);
